import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    containerTabla: {
        marginTop: "20px",
        border: "1px solid #ECEFF1",
        borderRadius: "8px",
        display:'block',
        height: '350px'
    },

    titulo: {
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '43px',
        color: '#02599E',
    },

    paginationTabla: {
        fontFamil: 'Rubik',
        marginTop: '20px',
        fontWeight: '500',
        fontSize: '14px',
        color: '#011328',
        display: 'flex',
        position: 'relative',
        alignitems: 'center',
        justifycontent: 'flex-start',
        flexwrap: 'wrap',
        '& .MuiIconButton-root': {
            '&:focus': {
                outline: 'none',
            },
        },
    },

    inputFrom: {
        width: '58px',
    },
    containerLapiz: {
        marginLeft: '5px',
        justifyContent: 'center',
        alignItems: 'center',
        '&:focus': {
            outline: 'none',
        },
    },

    containerAdvertencia: {
        '&:focus': {
            outline: 'none',
        },
    },

    lapizIcono: {
        width: '12px',
        height: '12px',
    },

    advertenciaIcono: {
        width: '20px',
        height: '20px',
        color: '#FF0000',
        border: '1px solid #FF0000',
        borderRadius: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    backdrop: {
        zIndex: 10,
        color: '#fff',
    },

    estado: {
        height: '24px',
        borderRadius: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center ',
        padding: '5px',
        fontFamily: 'Rubik',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '14px',
        minWidth: '97px',
        width: "110px",
    },

    verificacion: {
        color: '#4D5053',
        border: '1px solid #4D5053',
    },

    observado: {
        color: '#02599E',
        border: '1px solid #02599E',
    },

    rechazado: {
        color: '#D01919',
        border: '1px solid #D01919',
    },

    finalizado: {
        color: '#007320',
        border: '1px solid #007320',
    },

    colEstado: {
        width: "110px",
        padding: "14px 1px !important",
    },

    colRazonSocial: {
        width: "200px",
        padding: "14px 0px !important",
    },

    textoVentana: {
        fontWeight: '300',
        fontSize: '16px',
        lineHeight: '28px',
        letterSpacing: '0.15px',
        color: '#666666',
    },
    contadorFiltro:{
        fontFamily: 'Rubik',
        marginTop: '0px'
    },
    contadorFiltroNumero:{
        fontWeight:'500',
    },
    tableHeader:{
        position:'sticky',
        top: '0',
        zIndex: '4'
    },

    filaContainer: {
        // marginButton: '2rem',
        marginTop:'20px',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '0px',
        paddingRight: '0px',
    },

    filaContainerBoton: {
        // marginButton: '2rem',
        marginTop:'20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'right',
        paddingLeft: '0px',
        paddingRight: '0px',
    },
    boxContainer:{
        marginTop:'10px',
    },
    placeholderPaginationInputNumber: {
        '&::placeholder': {
            color: 'black',
            opacity: 1
        }
    }
});
